import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import './accountlogin.css';
import userProfileImg from '../../resources/img/user-account-icon.png';
import loginImg from '../../resources/img/user-icon-not-logged-in.png';
import downIcon from '../../resources/img/down-icon.png';
import { EDIT_PROFILE_ROUTE, LOGIN_ROUTE, PROFILE_ROUTE } from "../../../SHARED/config/routes";
import { getUserDetails, getUnviewedNotificationsCount } from "../../../SHARED/actions/profile.actions";
import { API_URL } from '../../../SHARED/config/apiEndpoints';
import { withRouter } from "react-router";
import ModalApps from "../../../SHARED/components/modalapps/modalapps.component";
import { isEmpty } from "../../../SHARED/helpers/general.helper";
import Parser from "html-react-parser";


class AccountLogin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            width: '0',
            windowWidth: 0,
            auth_token: window.localStorage.getItem("access_token"),
            openAppsModal: false,
            searchedText: ''
        };


        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentWillMount() {
        if (localStorage.getItem('login_type') === 'authenticated') {
            this.props.getUserDetails();
            this.props.getUnviewedNotificationsCount();
        }
    }

    componentWillReceiveProps(nextProps) {
        //Refresh profile page with new added data since the profile was edited in the "edit profile page"
        if (this.props.location.pathname === EDIT_PROFILE_ROUTE && nextProps.location.pathname === PROFILE_ROUTE) {
            this.props.getUserDetails();
        }
    }


    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ windowWidth: window.innerWidth });
    }

    expandSearchBar = (e) => {

        const newWidth = '40%';

        if (this.state.width === '0') {
            document.getElementById("search-input").focus();
            this.setState({
                width: newWidth
            })
        } else {
            if (!this.state.searchedText) {
                this.setState({
                    width: '0'
                })
            } else {
                this.search(this.state.searchedText)
            }
        }
    };

    searchSite(e) {
        if (e.keyCode === 13) {
            this.search(this.state.searchedText);
        }
    }

    search(text) {
        text = text.trim();
        if (text.length > 2) {
            if (text) {
                if (this.props.history.location.pathname.search('cautare') > 0) {
                    this.props.history.push('/cautare/' + text);
                    window.location.reload()
                } else {
                    this.props.history.push('/cautare/' + text);
                }
                this.setState({ searchedText: '' });
            }
        }
    }

    openAppsModal = () => {
        this.setState({
            openAppsModal: true
        });
    };

    toggle(which) {
        this.setState({
            openAppsModal: !this.state.openAppsModal,
        });
    }

    render() {

        const getAccountSectionCondition = () => {
            if (window.localStorage.getItem("login_type") !== 'anonymous' && window.localStorage.getItem("login_type") !== null) {
                return (
                    <Link to={PROFILE_ROUTE}>
                        <div className="notification">
                            <img src={this.props.profileImg !== "" ? API_URL + Parser(this.props.profileImg) : userProfileImg} alt={"Cinemap"} className="img-fluid rounded-circle" />
                            <span className="notification-number">{this.props.notificationCount}</span>
                        </div>
                    </Link>
                );
            } else {
                return (
                    <a href={LOGIN_ROUTE}>
                        <img src={loginImg} alt={"Cinemap"} className="img-fluid" />
                    </a>

                );
            }
        };

        return (
            <div className="account-login clearfix">
                <ModalApps
                    toggle={() => this.toggle('share')}
                    openModal={this.state.openAppsModal}
                    className={"modalApps"}
                />

                <div className="wrapper-header-icons">

                    <div className="search-website header-icon">
                        <img src={downIcon} alt={"Cinemap"} className="img-fluid" onClick={this.openAppsModal} />
                    </div>

                    <div className="user-profile header-icon">
                        {getAccountSectionCondition()}
                    </div>

                    <span className="search-overlay header-icon" onClick={this.expandSearchBar} />
                    <input type="text" id="search-input" onChange={(e) => this.setState({ searchedText: e.target.value })} className="search-site" style={{ width: this.state.width }} onKeyDown={this.searchSite.bind(this)} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    login_type: state.user.login_type,
    profileImg: !isEmpty(state.profile.userDetails) ? state.profile.userDetails.picture : '',
    notificationCount: state.profile.notificationCount.notif_count
});
export default withRouter(connect(mapStateToProps, { getUserDetails, getUnviewedNotificationsCount })(AccountLogin));



// WEBPACK FOOTER //
// ./src/FO/components/accountlogin/accountlogin.component.js